import {
  ADD_TO_SOCKET_LIST,
  EXECUTE_SOCKET_LIST,
} from '../../state/actionTypes';

const defaultState = {
  socketUserMap: {},
};

export default function socketReducer(state = defaultState, action) {
  switch (action.type) {
    case ADD_TO_SOCKET_LIST: {
      if (action.payload.isApprovals && state.socketUserMap.approvals) {
        return state;
      }

      return {
        ...state,
        socketUserMap: {
          ...state.socketUserMap,
          [action.payload.userId]: [
            ...(state.socketUserMap[action.payload.userId] || []),
            action.payload.data,
          ],
        },
      };
    }
    case EXECUTE_SOCKET_LIST: {
      const newSocketUserMap = { ...state.socketUserMap };
      action.payload.forEach((userId) => {
        delete newSocketUserMap[userId];
      });

      if (newSocketUserMap.approvals) {
        delete newSocketUserMap.approvals;
      }

      return {
        ...state,
        socketUserMap: newSocketUserMap,
      };
    }
    default:
      return state;
  }
}
